module.exports = __webpack_public_path__ + "img/review-avatar.e8f6159.png";